import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import Filters from './Filters';
import Icon from '../../../molecules/Icon';
import ExternalSearchBar from '../../../molecules/Search/ExternalSearch';

import { color } from '../../../atoms/colors';
import {
  CategoryFilters,
  Container,
  Text,
  Wrapper,
} from '../styles/Header.styled';

const Header = ({
  filters,
  filterState,
  activeFilters,
  setActiveFilters,
  setMobileFilterActive,
  sortOrder,
  setSortOrder,
  currentPosts,
  totalPosts,
  type,
  hideSearch,
}) => {
  const { t } = useTranslation();
  const [isSticky, setIsSticky] = useState(false);
  const headerRef = useRef(null);
  const activeFiltersCount = Object.values(activeFilters).reduce(
    (acc, curr) => acc + curr.length,
    0
  );

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const topPosition = headerRef.current.getBoundingClientRect().top;
        setIsSticky(topPosition <= 80);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Container ref={headerRef} className={isSticky ? 'scrolled' : ''}>
      <Wrapper>
        <Text>
          <div>
            <button
              type="button"
              className="mobile-filter-btn"
              onClick={() => setMobileFilterActive(true)}
            >
              <Icon
                id="settings-04"
                strokeColor={color.darkBlue[1000]}
                width="20px"
                height="20px"
              />
              {t('Filters')}
              {activeFiltersCount > 0 && (
                <span className="filter-count">{activeFiltersCount}</span>
              )}
            </button>
            <p className="label">Filter your results</p>
          </div>
          <p className="count">
            {t('Showing')} <b>{currentPosts}</b> {t('of')} <b>{totalPosts}</b>
          </p>
        </Text>
        <CategoryFilters
          hideSearch={hideSearch}
          className={isSticky ? 'scrolled' : ''}
        >
          <Filters
            filters={filters}
            filterState={filterState}
            activeFilters={activeFilters}
            setActiveFilters={setActiveFilters}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
          />
          {!hideSearch && <ExternalSearchBar type={type} />}
        </CategoryFilters>
      </Wrapper>
    </Container>
  );
};

export default Header;
